import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setDocumentFavicon } from "@/utils/document-favicon.utils";
import { setDocumentTitle } from "@/utils/document-title.utils";

/** Keeps the browser tab title and favicon in sync with the current route/app. */
export function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    setDocumentTitle(pathname);
    setDocumentFavicon(pathname);
  }, [pathname]);

  return null;
}
